import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";

import AuthBackgroundBanner from "public/images/sacramentokings_flex/kings_banner.png";
import FindGamesBanner from "public/images/sacramentokings_flex/kings_banner.png";
import SeatMap3dPreviewImage from "public/images/sacramentokings_flex/sacramento_kings_cover.jpeg";

import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import {
  faqs,
  howItWorks,
  purchaseSeatsLanguages,
  purchaseGiftCardLanguages,
} from "./helpers";

import type { TeamConfig } from "../types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png";

const config: TeamConfig = {
  teamSchema: "sacramentokings_flex",
  browserTitle: "Sacramento Kings Flex Plans",
  packages: false,
  teamName: "Sacramento Kings",

  packs: {
    enabled: true,
    list: [
      {
        id: 1,
        amount: 3,
        title: "3 Game Pack",
        description: "Choose a total of 3 games for 10% off your ticket price!",
        offerMoreMessage:
          "Would you like to add 3 more games and get 15% off your tickets?",
        defaultSelected: true,
        buckets: [
          {
            id: 1,
            title: "Pick 3 games",
            description: "",
            max: 3,
            min: 3,
            dontCloseWhenHitMin: true,
          },
        ],
        updatedAccountGroup: 0,
        successMessage:
          "Congratulations! you have unlocked 10% off your tickets.",
      },
      // {
      //   id: 2,
      //   amount: 6,
      //   title: "6 Game Pack",
      //   description: "Choose a total of 6 games for 15% off your ticket price!",
      //   offerMoreMessage:
      //     "Would you like to add 2 more games and get 20% off your tickets?",
      //   defaultSelected: true,
      //   buckets: [
      //     {
      //       id: 1,
      //       title: "Pick 6 Games",
      //       description: "",
      //       max: 6,
      //       min: 6,
      //       dontCloseWhenHitMin: true,
      //     },
      //   ],
      //   updatedAccountGroup: 1,
      //   successMessage:
      //     "Congratulations! you have unlocked 15% off your tickets.",
      // },
      // {
      //   id: 3,
      //   amount: 8,
      //   title: "8 Game Pack",
      //   description: "Choose a total of 8 games for 20% off your ticket price!",
      //   offerMoreMessage: "",
      //   buckets: [
      //     {
      //       id: 1,
      //       title: "Pick 8 Games",
      //       description: "",
      //       max: 8,
      //       min: 8,
      //       dontCloseWhenHitMin: true,
      //     },
      //   ],
      //   updatedAccountGroup: 2,
      //   successMessage:
      //     "Congratulations! you have unlocked 20% off your tickets.",
      // },
    ],
  },

  manageCard: true,

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.giftCard,
    hideRedeemItem: true,
    hideRecipient: true,
  },

  // disabled routes
  disabledRoutes: [],

  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00073-kings-sec",
    mapId: "main",
  },

  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    isCheckoutEditSeatsEnabled: true,
    isDiffSeatAlertEnabled: true,
    checkoutTimerEnabled: false,
    showFrontendTotalAmount: true,
    showFrontendServiceFee: true,
    allowManualCartInSimilar: true,
    isPerksEnabled: false,
    defaultSeatCount: 2,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: true,
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  isBrainTreePaymentEnabled: false,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    metaPixelId: "1846888515544840",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/sackings/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBackgroundBanner.src,
    checkoutStatusPageImage: AuthBackgroundBanner.src,
    giftCardStandalonePageImage: AuthBackgroundBanner.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreviewImage.src,
  },

  colors: {
    primary: "#5b2c81",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    hideCheckoutCartBalance: false,

    checkoutStatusPage: {
      checkoutSuccessMessageFontSize: "16px",
      checkoutSuccessMessageFontWeight: "normal",
    },
  },

  languages: {
    topNavMenuItems: <></>,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: null,
    purchaseSeats: purchaseSeatsLanguages,

    checkoutSuccessMessage:
      "Tickets are now available to view in your Sacramento Kings Account Manager!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Canada Life Centre.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Canada Life Centre.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to yout account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
